export const enum CollectionContentTableQa {
    Table = 'coll-content-table',
    CollectionLinkRow = 'coll-content-table-coll-link-row',
    WorkbookLinkRow = 'coll-content-table-workbook-link-row',
    EntryLinkRow = 'coll-content-table-entry-link-row',
    CollectionTitleCell = 'coll-content-table-coll-title-cell',
}

export const enum DialogCollectionStructureQa {
    ApplyButton = 'coll-structure-dialog-apply-button',
    ListItem = 'coll-structure-dialog-list-item',
}
